import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getQuestions, createQuestion, updateQuestion, deleteQuestion } from '../services/questionsService'

export const useQuestions = () => {
  return useQuery({
    queryKey: ['questions'],
    queryFn: getQuestions,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1, // retry once on failure
  })
}

export const useCreateQuestion = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createQuestion,
    onSuccess: () => {
      // when a user is created, refetch the users list
      queryClient.invalidateQueries({ queryKey: ['questions'] })
    },
  })
}

export const useUpdateQuestion = () => {
  const queryClient = useQueryClient()
  return useMutation({ 
    mutationFn: updateQuestion, 
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questions'] })
    },
  })
}

export const useDeleteQuestion = () => {
  const queryClient = useQueryClient() 
  return useMutation({ 
    mutationFn: deleteQuestion, 
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questions'] })
    },
  })
}
